export default __webpack_public_path__ + "static/screeny-85-gpz-s-6-68057217293556ecfb519588462eb88d.jpg";